export default __webpack_public_path__ + "media/eb730a0762112ca56d98195ce4217d7bf1fa16fbea70f2e82db3ee49ef352857.svg";